<template>
<div class="Filetree">
  <div class="container">
    <div class="row">
      <div class="col s12 m7"> &nbsp; </div>
      <div class="col s12 m5 pb25">
        <div class="row listing">
          <h1 class="titleh1 text-left">FILE TREE</h1>
          <ul>
            <li v-for="menu in PageData.Category">
              <router-link :to="menu.Link">{{menu.Category}}</router-link>
              <ul>
                <li v-for="submenu in menu.Sub">
                  <span v-if="submenu.Target == 'blank'">
                    <a target="_blank" :href="submenu.Link">{{submenu.CategoryName}}</a>
                  </span>
                  <span v-else>
                    <router-link :to="submenu.Link">{{submenu.CategoryName}}</router-link>
                  </span>
                  <ul>
                    <li v-for="submenu2 in submenu.Sub">
                      <span v-if="submenu2.Target == 'blank'">
                        <a target="_blank" :href="submenu2.Link">{{submenu2.CategoryName}}</a>
                      </span>
                      <span v-else>
                        <router-link :to="submenu2.Link">{{submenu2.CategoryName}}</router-link>
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <FooterText />
</div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import FooterText from './Footertext'
export default {
  name: 'Filetree',
  data() {
    return {
      usercookie: $cookies.get('arch-asic'),
      PageData: []
    }
  },
  components: {
    FooterText
  },
  methods: {
    show() {
      this.$modal.show('info');
    },
    hide() {
      this.$modal.hide('info');
    },
    fetchDataTree: function() {
      axios({
        method: 'get',
        url: 'https://www.archipelagointernational.com/api/asic/get-filetree',
        headers: {
          'Authorization': 'Bearer ' + this.usercookie,
        }
      }).then(response => (this.PageData = response.data));
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loginstatus: function(e) {
      if (e != 'Success') {
        //console.log(e);
        router.push({
          name: 'Login'
        })
      } else {
        //this.isLogin = true
        //console.log(e);
      }
    }
  },
  created() {
    this.fetchDataTree();
  },
  mounted() {
    this.toggleBodyClass('removeClass', 'bm-overlay');
    this.toggleBodyClass('addClass', 'back-dashboard');
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'back-dashboard');
  }
}
</script>

<style>
.back-dashboard {
  background: url('https://cdn0.archipelagointernational.com/StaffCentre/assets/images/test2.jpg') center center no-repeat fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: #fff;
}

.titleh1 {
  font-size: 30px;
  color: #fff;
  margin-bottom: 35px;
  margin-top: 35px;
  font-weight: 700
}

.titleh2 {
  font-size: 25px;
  color: #fff;
  margin-bottom: 14px
}

.f12 {
  font-size: 12px
}

.pb25 {
  padding-bottom: 25px
}


@media (max-width:991px) {
  .quick-nav {
    top: 120px;
    margin-top: 0
  }
}

@media (max-width:1366px) {
  .box-home {
    margin-top: 5px !important
  }
}

@media (min-width:1366px) {
  .container {
    width: 1200px;
    margin: 0 auto
  }
}

.listing ul {
  margin-left: 25px;
}

.listing ul li {
  list-style: disc;
}

.listing ul li a,
.listing ul li a:hover {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Filetree.vue